import common from '../common';
import Scene from './Scene';
import {translate, Text} from '../utils';

export default class SplashScene extends Scene {
	constructor() {
		super();

		this._playButton = null;
		this._buttonBurst = null;
		this._muteButton = null;
		this._menuMusic = null;
	}

	init() {
		super.init();

		let bg = new PIXI.Sprite(P3.assets.texture('bg_splash'));
		bg.anchor.set(0.5);
		bg.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this.addChild(bg);

		let comic = new PIXI.Sprite(P3.assets.texture('comic'));
		comic.anchor.set(0.5, 1);
		comic.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT);
		this.addChild(comic);

		let brush1 = new PIXI.Sprite(P3.assets.texture('medium_001'));
		brush1.anchor.set(0.5, 1);
		brush1.rotation = -0.30;
		brush1.position.set(common.STAGE_WIDTH * 0.32, common.STAGE_HEIGHT * 0.8);
		this.addChild(brush1);

		let brush2 = new PIXI.Sprite(P3.assets.texture('medium_001'));
		brush2.anchor.set(0.5, 1);
		brush2.rotation = -0.60;
		brush2.position.set(common.STAGE_WIDTH * 0.32, common.STAGE_HEIGHT * 0.76);
		this.addChild(brush2);

		let jerryHead = new PIXI.Sprite(P3.assets.texture('ph_jerry'));
		jerryHead.anchor.set(0.5);
		jerryHead.position.set(common.STAGE_WIDTH * 0.36, common.STAGE_HEIGHT * 0.66);
		this.addChild(jerryHead);

		let panel = new PIXI.Sprite(P3.assets.texture('panel'));
		panel.anchor.set(0.5);
		panel.position.set(common.STAGE_WIDTH * 0.5 - 25, common.STAGE_HEIGHT * 0.5 + 214);
		this.addChild(panel);

		let logo = new PIXI.Sprite(P3.assets.texture('logo'));
		logo.anchor.set(0.5);
		logo.position.set(common.STAGE_WIDTH * 0.5 - 25, common.STAGE_HEIGHT * 0.5 + 214);
		this.addChild(logo);

		let tomHead = new PIXI.Sprite(P3.assets.texture('ph_tom'));
		tomHead.anchor.set(0.5);
		tomHead.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 - 30);
		this.addChild(tomHead);

		let pencil = new PIXI.Sprite(P3.assets.texture('pencil'));
		pencil.anchor.set(0.5);
		pencil.position.set(common.STAGE_WIDTH * 0.5 + 220, common.STAGE_HEIGHT * 0.5 + 18);
		this.addChild(pencil);

		if (common.config.language === 'ar') {
			let arTitle = new PIXI.Sprite(P3.assets.texture('title_ar'));
			arTitle.anchor.set(0.5);
			arTitle.position.set(common.STAGE_WIDTH * 0.5 + 40, 140);
			this.addChild(arTitle);
		} else {
			let titleText = new Text(translate('game_title'), {fontSize: 52, fontFamily: 'GrilledCheese BTN', align: 'center', colour: 0xFFFFFF});
			titleText.anchor.set(0.5);
			titleText.position.set(common.STAGE_WIDTH * 0.5 + 40, 140);
			titleText.maxWidth = 410;
			this.addChild(titleText);
		}

		let boomerangLogo = new PIXI.Sprite(P3.assets.texture('boomerang'));
		boomerangLogo.anchor.set(0.5);
		boomerangLogo.position.set(common.STAGE_WIDTH * 0.5 - 250, 140);
		this.addChild(boomerangLogo);

		this._buttonBurst = new PIXI.Sprite(P3.assets.texture('burst'));
		this._buttonBurst.anchor.set(0.5);
		this._buttonBurst.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 - 100, common.STAGE_HEIGHT - this._buttonBurst.height * 0.5);
		this.addChild(this._buttonBurst);

		let states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_pri_large_over');
		states.over = P3.assets.texture('btn_pri_large_over');
		states.down = P3.assets.texture('btn_pri_large_down');
		states.icon = P3.assets.texture('icon_pri_large_out');
		states.iconDown = P3.assets.texture('icon_pri_large_down');
		states.iconOver = P3.assets.texture('icon_pri_large_over');

		this._playButton = new P3.Button(states);
		this._playButton.position.set(0, 0);
		this._playButton.scale.set(0.8);
		this._playButton.signals.click.add(this.onPlayButtonClick, this);
		this._buttonBurst.addChild(this._playButton);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_pri_small_out');
		states.over = P3.assets.texture('btn_pri_small_over');
		states.down = P3.assets.texture('btn_pri_small_down');
		states.icon = P3.assets.texture('icon_pri_sound_out');
		states.iconDown = P3.assets.texture('icon_pri_sound_down');
		//states.iconOver = P3.assets.texture("icon_pri_home_over");           // this one crashes
		states.iconAlt = P3.assets.texture('icon_pri_mute_out');
		states.iconDownAlt = P3.assets.texture('icon_pri_mute_down');
		states.iconOverAlt = P3.assets.texture('icon_pri_mute_over'); // this one doesnt show

		this._muteButton = new P3.MuteButton(states);
		this.addChild(this._muteButton);

		this._menuMusic = P3.audio.playMusic('music_menu_loop_00');
	}

	destroy() {
		this._playButton.destroy();
		this._muteButton.destroy();

		super.destroy();
	}

	resize() {
		super.resize();

		this._muteButton.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 - 100, 100);
		this._buttonBurst.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 100;
	}

	update() {
		super.update();
	}

	onPlayButtonClick() {
		this.signals.next.dispatch(this);
	}
}
